import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { permissionsKeys } from './permissions-keys';

import type { Permission, PermissionsPayload } from '../permissions.dto';

export async function getPermissions(): Promise<Permission[]> {
  const res = await makeRequest<{ payload: PermissionsPayload }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v1/dashboard/get-permissions`,
    withCredentials: true,
  });
  return res.payload.permissions;
}

export const useGetPermissions = (
  options: Omit<UseQueryOptions<Permission[]>, 'queryKey' | 'queryFn'> = {}
) => {
  return useQuery({
    // Permissions are immutable within a session; keep them fresh across the
    // many call sites (guards, nav, tabs, export buttons) instead of refetching
    // on every mount. Callers may still override via `options`.
    staleTime: Infinity,
    ...options,
    queryKey: permissionsKeys.all(),
    queryFn: getPermissions,
  });
};
